import { FlashVersion } from "./utils/flash_version";
import { Uap } from "./utils/uap";
import ConnectionAdapter from './adapters/connection_adapter';
import LocationAdapter from './adapters/location_adapter';
import isFeatureToggleOn from "./utils/feature_toggle";

export class PlayerEnvironment {
  static flashVersion() {
    return (this._flashVersion = (this._flashVersion || (new FlashVersion()).get()));
  }

  static uaParser(){
    this._uaParser = this._uaParser || new Uap();
    return this._uaParser;
  }

  static browserName(){
    return this.uaParser().getBrowser().name;
  }

  static browserVersion(){
    return this.uaParser().getBrowser().version;
  }

  static browserVersionMajor(){
    return parseInt(this.uaParser().getBrowser().major);
  }

  static osName(){
    return this.uaParser().getOS().name;
  }

  static osVersion(){
    return this.uaParser().getOS().version;
  }

  static osVersionMajor(){
    let osVersion = this.osVersion();
    return osVersion ? osVersion.split(".")[0] : "";
  }

  static deviceModel(){
    return this.uaParser().getDevice().model;
  }

  static deviceVendor(){
    return this.uaParser().getDevice().vendor;
  }

  static platform(){
    if (PlayerEnvironment.isMobileSite()) {
      return 'web-mobile';
    }
    if (PlayerEnvironment.isMicroSite()) {
      return PlayerEnvironment.utmSource();
    }
    return 'web-desktop';
  }

  static referrer(){
    return document.referrer;
  }

  static pathname(){
    return location.pathname;
  }

  static currentEnv(){
    return {
      flash_version: this.flashVersion(),
      browser_name: this.browserName(),
      browser_version: this.browserVersion(),
      os_name: this.osName(),
      os_version: this.osVersion(),
      device_model: this.deviceModel(),
      device_vendor: this.deviceVendor(),
      platform: this.platform(),
      referrer: this.referrer(),
      app_name: 'vidio',
      event_time: this.eventTime(),
      vp9_support: this.isSupportVp9(),
      lite_mode: ConnectionAdapter.liteModeEnabled(),
      user_agent: navigator.userAgent,
      connection_speed: ConnectionAdapter.downlink(),
      connection: ConnectionAdapter.effectiveType()
    };
  }

  static hostname(){
    return location.hostname;
  }

  static locationSearch() {
    return location.search;
  }

  static locationHref() {
    return location.href;
  }

  static utmSource(){
    var utmSource = this.locationSearch().match(/utm_source=([a-zA-Z0-9-_]*)/i);
    if(utmSource && utmSource[1]) {
      return utmSource[1];
    }
    return null;
  }

  static isDesktopSite(){
    return !this.isMobileSite();
  }

  static isMobileSite(){
    return !!this.hostname().match(/^(m|lite)\./);
  }

  static isLiteSite(){
    return !!this.hostname().match(/^lite\./);
  }

  static isMicroSite() {
    return !!this.locationHref().match(/vidio\.[a-zA-Z0-9:]*\/micro\/live/);
  }

  static isPrerollAdsEnabled(){
    const browserName = this.browserName();
    const browserVersion = this.browserVersion();
    const osName = this.osName();
    const browserVersionMoreThan = x => {
      return browserVersion.substring(0, browserVersion.indexOf('.')) >= x;
    }

    if(osName == 'iOS') return isFeatureToggleOn('enable_preroll_on_ios');
    if(osName == 'Android') {
      if (browserName.startsWith('Samsung') && browserVersionMoreThan(5)) return true;
      
      if (browserVersionMoreThan(39)) return true;

      return false
    }
    return true;
  }

  static eventTime() {
    return new Date().toISOString();
  }

  static hasAdBlocker() {
    const img = document.querySelector('.ads img');

    if (img) {
      return getComputedStyle(img).display === 'none';
    } else {
      return false;
    }
  }

  static isOSiOS() {
    return PlayerEnvironment.osName().toLowerCase() === 'ios';
  }

  static isBrowserSafari() {
    return ['Safari', 'Mobile Safari'].includes(PlayerEnvironment.browserName());
  }

  static isSupportVp9() {
    if (this.osName() == 'iOS')
      return false;

    const browserName = this.browserName();
    const browserVersion = this.browserVersion();
    const browserVersionMoreThan = x => {
      return browserVersion.substring(0, browserVersion.indexOf('.')) >= x;
    }

    if (browserName.startsWith('Chrome')) {
      if (browserVersionMoreThan(29)) return true;
    }

    if (browserName == 'Edge') {
      if (browserVersionMoreThan(14)) return true;
    }

    if (browserName == 'Firefox') {
      if (browserVersionMoreThan(28)) return true;
    }

    if (browserName == 'Opera') {
      if (browserVersionMoreThan(11)) return true;
    }

    return false;
  }

  static isWatchPage() {
    const url = new URL(LocationAdapter.href());
    const pathname = url.pathname;

    if (pathname.includes('/embed')) return false;

    const matched = pathname.match(/\/(watch|live)\//g);

    if (matched === null) return false;

    return !!matched.length;
  }
}
